// extracted by mini-css-extract-plugin
module.exports = {"block":"block___3tF4G","aboutPanel":"aboutPanel___2Nbuy"};